import { useRef, useState } from "react";
import "./post-location-search.css";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import FormFieldError from "../../../components/form-field-error/form-field-error";
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import PropertyApiService from "../../../data/api/services/property/property-api-service";
import ValidationError from "../../../common/validation-error";
import ProfessionalPageApiService from "../../../data/api/services/professional-page/professional-page-api-service";
import LocationApiService from "../../../data/api/services/location/location-api-service";
import { Carousel, Col, Row } from 'react-bootstrap';
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImage, faMapMarkerAlt, faTimes } from '@fortawesome/free-solid-svg-icons';
import VerifiedIcon from '@mui/icons-material/Verified';
import Tooltip from '@mui/material/Tooltip';

const PostLocationSearch = (props: any) => {

    const professionalPageApiservice = new ProfessionalPageApiService();
    const locationApiService = new LocationApiService
    const propertyApiService = new PropertyApiService();
    const properyCoverImageInput: any = useRef(null);
    const [locationSearchLoading, setLocationSearchLoading] = useState(false);
    const [locationData, setLocationData] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState<any>([]);
    const [toDeleteImageId, setToDeleteImageId] = useState(0);
    const [callToActionData, setCallToActionData] = useState([]);
    const [callToActionIdStr, setCallToActionIdStr] = useState("");
    const [showCallToActionOption, setShowCallToActionOption] = useState(true);
    const [description, setDescription] = useState('');
    const [callToActionUrl, setCallToActionUrl] = useState('');
    const [professionalPagePosts, setProfessionalPagePosts] = useState<any>([]);
    const [postImage, setPostImage] = useState<any>([]);
    const [index, setIndex] = useState(0);
    const [locationValidationErrorMsg, setLocationValidationNameErrorMsg] = useState(null);
    const [callToActionValidationErrorMsg, setCallToActionValidationErrorMsg] = useState(null);
    const [professionalPagePostFormData, setProfessionalPagePostFormData] = useState<any>(new FormData());
    const [professionalPostFormData, setProfessionalPostFormData] = useState<any>(new FormData());
    const [isAudienceVisible, setIsAudienceVisible] = useState(false);

    const toggleAudience = () => {
      setIsAudienceVisible(!isAudienceVisible);
    };
    const [descriptionValidationErrorMsg, setDescriptionValidationErrorMsg] = useState(null);
    const [callToActionUrlValidationErrorMsg, setCallToActionUrlValidationErrorMsg] = useState(null);

    const [postImageValidationErrorMsg, setPostImageValidationErrorMsg] = useState('');
    const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
    const [carouselKey, setCarouselKey] = useState(0);
    const [confirmationDialogParams, setConfirmationDialogParams] = useState({
        title: '',
        message: '',
        onConfirm: () => { },
    });


    const locationContainer = [
        {
            name: "Location",
            color: "black"
        },
  
        {
            name: "Pincode",
            color: "blue"
        },
        {
            name: "PostOffice",
            color: "red"
        },
        {
            name: "Taluka",
            color: "green"
        },
        {
            name: "District",
            color: "orange"
        },
        {
            name: "State",
            color: "#fa0acc"
        },
    ]



    const onUploadPostListener = (e: any) => {
        if (e.currentTarget.files) {
            let newImages: any = [];
            for (let i = 0; i < e.currentTarget.files.length; i++) {
                let newImage: any = {};
                newImage.file = e.currentTarget.files[i];
                newImage.url = URL.createObjectURL(newImage.file);
                newImages.push(newImage);
            }
            setPostImage((prevImages) => [...prevImages, ...newImages]);
            setPostImageValidationErrorMsg('');
        } else {
            console.error("No files found in the event");
        }
    };


    const clearCoverImage = (index: number) => {
        const updatedImages = [...postImage];
        updatedImages.splice(index, 1);
        setPostImage(updatedImages);
        setCarouselKey((prevKey) => prevKey + 1);
    }

    const deleteProfessionalPagePost = async (id: any, imageId: any) => {
        try {
            if (id) {
                await professionalPageApiservice.deleteProfessionalpagePostImage(id, imageId);

                return;
            }
        } catch (error) {
            console.log("ERROR occured deleteProperty() error=== " + JSON.stringify(error));
        }
    };


    const onProfessionalPageUploadPostListener = (event: any) => {
        const files = event.target.files;
        if (files.length > 0) {
            let mediaFiles: any = [];
            for (let i = 0; i < files.length; i++) {
                let mediaFile: any = {};
                mediaFile.file = files[i];
                if (mediaFile.file.type.startsWith('image/')) {
                    mediaFile.mimeType = 'IMAGE';
                }
                else if (mediaFile.file.type.startsWith('video/')) {
                    mediaFile.mimeType = 'VIDEO';
                }
                mediaFile.imagePath = URL.createObjectURL(mediaFile.file);
                mediaFiles.push(mediaFile);
            }
            setPostImage(prevImages => [...prevImages, ...mediaFiles]);
        } else {
            setPostImage([]);
        }
    }

    const validateUploadPostFormData = (): void => {
        let errors: any[] = [];

        if (selectedLocation.length === 0) {
            let error: any = {};
            error.validationCode = "taggedLocationIdStr";
            error.message = 'Location required';
            errors.push(error);
        }


        if (postImage <= 0) {
            let error: any = {};
            error.validationCode = "mediaUrl";
            error.message = 'Image required';
            errors.push(error);
        }

        if (errors.length > 0) {
            throw new ValidationError(errors);
        }
    }

    const showValidationErrorInlineUI = (error: ValidationError) => {
        let errors: any[] = error.errors;
        for (let i = 0; i < errors.length; i++) {
            let error: any = errors[i];
            let errorCode: any = error.validationCode;
            let errorMsg: any = error.message;

            if (errorCode === 'mediaUrl') {
                setPostImageValidationErrorMsg(errorMsg);
            }

            if (errorCode === 'taggedLocationIdStr') {
                setLocationValidationNameErrorMsg(errorMsg);
            }
        }
    }


    const handleRemoveImageConfirmation = (index: number) => {
        const imageData = professionalPagePosts.professionalPagePostImageGalleryData[index];
        if (imageData && imageData.id) {
            setConfirmationDialogParams({
                title: 'Remove Image',
                message: 'Are you sure to remove this image?',
                onConfirm: () => clearCoverImage(index),
            });
            setToDeleteImageId(imageData.id);
            setShowConfirmationDialog(true);
        } else {
            clearCoverImage(index);
        }
    };


    const handleConfirmDialog = () => {
        confirmationDialogParams.onConfirm();
        setShowConfirmationDialog(false);
        deleteProfessionalPagePost(professionalPagePosts.id, toDeleteImageId)
    };

    const handleCancelDialog = () => {
        setShowConfirmationDialog(false);
    };

    const searchLocation = async (q: any) => {
        setLocationSearchLoading(true);
        let data = await propertyApiService.searchLocation(q);
        console.log(q);
        setLocationSearchLoading(false);
        formatLocationData(data);
    };

    const formatLocationData = (data: any) => {
        formatLocationDataResponse(data);
        setLocationData(data);
    };

    const formatLocationDataResponse = (data: any) => {
        for (let i = 0; i < data.length; i++) {
            const formattedString = `${data[i].name} | <span style="color: blue;">${data[i].pinCode}</span> | ${data[i].postOfficeName} | <span style="color: red;">${data[i].talukaName}</span> | <span style="color: green;">${data[i].districtName}</span> | <span style="color: purple;">${data[i].abbreviation}</span>`;
            data[i].nameLabel = formattedString;
            data[i].formattedLocationDataHTML = { __html: formattedString };
        }
    };


    const handleSelect = (selectedIndex) => {
        setIndex(selectedIndex);
    };


    const renderMenuItemChildren = (option, props, index) => {
        return (
            <div key={index}>
                <span style={{ color: 'black', marginRight: '5px' }}>{option.name}</span>
    
                <Tooltip title={option.isVerified ? 'Verified Location' : 'Location Not Verified'}>
                    <VerifiedIcon 
                        sx={{
                            color: option.isVerified ? '#0d6efd' : 'grey',  
                            fontSize: '15px', 
                        }} 
                    />
                </Tooltip>
    
                {' | '}
                <span style={{ color: 'blue' }}>{option.pinCode}</span>
                {' | '}
                <span style={{ color: 'red' }}>{option.postOfficeName}</span>
                {' | '}
                <span style={{ color: 'green' }}>{option.talukaName}</span>
                {' | '}
                <span style={{ color: 'orange' }}>{option.districtName}</span>
                {' | '}
                <span style={{ color: '#fa0acc' }}>{option.abbreviation}</span>
            </div>
        );
    };
    
    
    
    
    

    const onLocationSelected = (e: any) => {
        if (e.length > 0) {
            console.log(e[0]);
            setSelectedLocation(e);
        }
        setLocationValidationNameErrorMsg('');
    };

    const clearSelectedLocation = () => {
        setSelectedLocation([]);
    };

    const selected = () => {
        let location = selectedLocation[0];
        props.handleClose(location)
    };

    return <>
       <div className="container">
      <div className="wrapper">
        <section className="post">
          <header>Crear un Comentario</header>
          <form action="#">
            <div className="content">
              <img src="https://imageshack.com/i/poXzrDlpp" alt="logo" />
              <div className="details">
                <p>CodeMaster</p>
                <div className="privacy" onClick={toggleAudience}>
                <FontAwesomeIcon icon={faImage} />
                  <span>Amigos</span>
                  <FontAwesomeIcon icon={faImage} />
                </div>
              </div>
            </div>
            <textarea placeholder="¿Qué tienes en mente, CodeMaster?" spellCheck="false" required />
            <div className="theme-emoji">
              <img src="https://imageshack.com/i/poD557QRp" alt="theme" />
              <img src="https://imageshack.com/i/poOSMz9vp" alt="smile" />
            </div>
            <div className="options">
              <p>Añadir a su puesto</p>
              <ul className="list">
                <li><img src="https://imageshack.com/i/pmXEMDk8p" alt="gallery" /></li>
                <li><img src="https://imageshack.com/i/pmqrumxbp" alt="gallery" /></li>
                <li><img src="https://imageshack.com/i/po7BYjbsp" alt="gallery" /></li>
                <li><img src="https://imageshack.com/i/pmpCcd2ap" alt="gallery" /></li>
                <li><img src="https://imageshack.com/i/pmBUIof1p" alt="gallery" /></li>
              </ul>
            </div>
            <button>Comentar</button>
          </form>
        </section>
        
 
          <section className="audience">
            <header>
              <div className="arrow-back" onClick={toggleAudience}>
                <i className="fas fa-arrow-left"></i>
              </div>
              <p>Seleccione el público</p>
            </header>
            <div className="content">
              <p>¿Quién puede ver su puesto?</p>
              <span>Tu publicación aparecerá en CodeMaster, en tu perfil y en los resultados de las búsquedas.</span>
            </div>
            <ul className="list">
              <li>
                <div className="column">
                  <div className="icon"><i className="fas fa-globe-asia"></i></div>
                  <div className="details">
                    <p>Public</p>
                    <span>Anyone on or off Facebook</span>
                  </div>
                </div>
                <div className="radio"></div>
              </li>
              <li className="active">
                <div className="column">
                  <div className="icon"><i className="fas fa-user-friends"></i></div>
                  <div className="details">
                    <p>Friends</p>
                    <span>Your friends on Facebook</span>
                  </div>
                </div>
                <div className="radio"></div>
              </li>
              <li>
                <div className="column">
                  <div className="icon"><i className="fas fa-user"></i></div>
                  <div className="details">
                    <p>Specific</p>
                    <span>Only show to some friends</span>
                  </div>
                </div>
                <div className="radio"></div>
              </li>
              <li>
                <div className="column">
                  <div className="icon"><i className="fas fa-lock"></i></div>
                  <div className="details">
                    <p>Only me</p>
                    <span>Only you can see your post</span>
                  </div>
                </div>
                <div className="radio"></div>
              </li>
              <li>
                <div className="column">
                  <div className="icon"><i className="fas fa-cog"></i></div>
                  <div className="details">
                    <p>Custom</p>
                    <span>Include and exclude friends</span>
                  </div>
                </div>
                <div className="radio"></div>
              </li>
            </ul>
          </section>
       
      </div>
    </div>
    </>
}
export default PostLocationSearch;